import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Spinner } from "@fluentui/react-components";
import { useMessage } from "../../../blocks/message/MessageContext";
import { noteFormFields } from "./NoteFormFields";
import { getEntityId } from "../../../utils/Helpers";
import { NOTICE_UID_FIELD_BY_ENTITY_ID } from "../../../utils/Constants";
import PageHeader from "../../../blocks/PageHeader";
import Ows from "../../../utils/OwsHandler";
import Form from "../../form/Form";

const NoteForm = () => {
  const { showMessage } = useMessage();
  const [loading, setLoading] = useState(false);
  const [noteTypes, setNoteTypes] = useState({});

  const location = useLocation();
  const navigate = useNavigate();
  const { uid, entity, skipPageHeader, selectedTab } = location.state || {};

  useEffect(() => {
    (async () => {
      try {
        const data = await Ows.handleRequest("Otys.Services.NoticeService.getTypesForEntity", [
          entity, 
          "Note"
        ]);
        
        if (data.error) {
          throw new Error(data.error.message);
        }
        
        setNoteTypes(data.response || {});
      } catch (error) {
        console.error(error);
      }
    })();
  }, [entity]);

  const createNote = async (formData) => {
    setLoading(true);
    try {
      const entityId = getEntityId(entity);
      const plan: Record<string, unknown> = {
        subject: formData.title,
        text: formData.description,
        typeId: formData.type,
        Bindings: [
          {
            entityId,
            uid,
          },
        ],
      };

      const uidField = NOTICE_UID_FIELD_BY_ENTITY_ID[entityId];
      if (uidField) {
        plan[uidField] = uid;
      }

      const data = await Ows.handleRequest("Otys.Services.NoticeService.add", [plan]);

      if (data.error) {
        throw new Error(data.error.message);
      }

      return data.response;
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (formData) => {
    const note = await createNote(formData);

    if (!note) {
      showMessage("error", "Failed to create note.");
    } else {
      showMessage("success", "Note created successfully.");
      handleBack();
    }
  };

  const handleBack = () => {
    navigate(`/${entity.toLowerCase()}/${uid}`, { state: { skipPageHeader, selectedTab} });
  };

  return (
    <div>
      <PageHeader onBack={handleBack} />
      <div style={{ padding: "20px" }}>
        {loading ? <Spinner /> : <Form title="Create new note" fields={noteFormFields(noteTypes)} onSubmit={handleSubmit} />}
      </div>
    </div>
  );
};

export default NoteForm;
